import { render, staticRenderFns } from "./BrandSettingLayout.vue?vue&type=template&id=1eb98d0b&"
import script from "./BrandSettingLayout.vue?vue&type=script&lang=js&"
export * from "./BrandSettingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports